export class PaymentModel {
    constructor() {
        this._products = [];
        this._metadata = {};
    }
    setProducts(products) {
        if (!Array.isArray(products) || products.length === 0) {
            throw new Error('Products must be a non-empty array');
        }
        for (const product of products) {
            if (!product.storeCode || typeof product.storeCode !== 'string') {
                throw new Error('Each product must have a valid storeCode');
            }
            if (!product.quantity || typeof product.quantity !== 'number' || product.quantity <= 0) {
                throw new Error('Each product must have a valid quantity greater than 0');
            }
        }
        this._products = [...products];
        return this;
    }
    setMetadata(metadata) {
        if (typeof metadata !== 'object' || metadata === null) {
            throw new Error('Metadata must be an object');
        }
        this._metadata = { ...metadata };
        return this;
    }
    get products() {
        return [...this._products];
    }
    get metadata() {
        return { ...this._metadata };
    }
    toJSON() {
        return {
            products: this._products,
            metadata: this._metadata
        };
    }
    static fromJSON(data) {
        const payment = new PaymentModel();
        payment._products = data.products || [];
        payment._metadata = data.metadata || {};
        return payment;
    }
}
